
import { BaseVue } from "@newview/base-web";
import searchCom from "./searchCom.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
declare let $: any; //declare 只能作用域最外层：
import XEUtils from "xe-utils";
import VXETable from "vxe-table";
import vxeCell from "./vxeGridCell.vue";
@Component({
  name: "grid",
  components: {
    searchCom,
    vxeCell,
  },
  computed: {},
})
export default class grid extends BaseVue {
  @Prop({ default: false })
  isCheckbox!: Boolean; //
  @Prop({ default: "" })
  operates!: any; // 模块按钮权限列表
  gridBoxId = "gridBox_" + this.NewGuid();
  gridEleId = "grid_" + this.NewGuid();
  defaultColWidth = "50px";
  @Prop({ default: "edit" })
  gridType!: String; //表格类型('view'只读，'edit'行内编辑)
  @Prop({ default: false })
  notCtrlBtn!: Boolean; //不控制按钮显示(true:不控制，false:控制)
  @Prop({ default: true })
  isToolBar!: Boolean; //是否显示上方工具栏按钮
  @Prop({ default: true })
  isShowAdd!: Boolean; //是否显示添加按钮
  @Prop({ default: true })
  isShowRefresh!: Boolean; //是否显示刷新按钮
  @Prop({ default: true })
  isShowSave!: Boolean; //是否显示保存按钮
  @Prop({ default: false })
  isShowSearch!: Boolean; //是否显示搜索按钮
  @Prop({ default: () => [] })
  toolBarCustom!: Array<Object>; //自定义工具栏按钮列表
  @Prop({ default: () => [] })
  toolBarCustom2!: Array<Object>; //自定义工具栏按钮列表
  @Prop({ default: "calc(100% - 30px)" })
  gridBoxHeight!: String; //表格高度
  @Prop({ default: null }) gridMaxHeight!: any; //表格最大高度
  @Prop({ default: false })
  loading!: Boolean; //表格是否处于加载中状态
  @Prop({ default: true })
  isPagination!: Boolean; //是否显示分页组件
  @Prop({ default: () => ({ total: 0, pageSize: 25, elevator: true }) })
  paginationSetting: Object | undefined; //分页参数
  @Prop({
    default: () => ({
      trigger: "click",
      mode: "row",
      showStatus: true,
      autoClear: false,
    }),
  })
  editconfig: Object | undefined; //表格编辑配置
  @Prop({ default: () => [] })
  ColConfig!: Array<any>; //列配置参数
  @Prop({ default: true })
  isSelectRow!: Boolean; //是否高亮选中某行
  @Prop({ default: () => [] }) gridData!: Array<any>; //表格数据
  @Prop({ default: "Id" })
  rowKey!: any; //表格数据
  @Prop({ default: () => ({}) })
  searchSetting?: any; //搜索条件配置参数
  @Prop({ default: () => ({}) })
  toolBarClick: any | undefined; //默认工具栏点击事件
  @Prop({ default: () => ({}) })
  rowOperation: any | undefined; //表格行内操作列配置参数
  @Prop({ default: false })
  showSummary!: boolean; // 显示合计
  @Prop({ default: () => ({}) })
  summaryMethod!: Function; // 合计方法
  @Prop({ default: () => 150 })
  handelColWidth!: number;
  @Prop({ default: "" })
  delMsgKey!: any; //删除提示语对应列的key
  @Prop({ default: () => ({ checkStrictly: true }) })
  checkConfig: any | undefined; //复选框配置项
  @Prop({ default: () => ({}) })
  expandconfig: any | undefined; //展开行配置项

  @Prop({ default: () => ({}) })
  customRenderer: any | undefined; 
  //关于懒加载
  @Prop({ default: false }) isLazy!: boolean; // 是否启用懒加载
  @Prop({ default: () => ({}) })
  loadChildrenMethod: any | undefined;
  @Prop({ default: () => ({}) })
  editRules: any | undefined; //编辑校验
  @Prop({ default: true }) showOverFlow!: Boolean; //	当内容过长时是否显示为省略号，默认是
  @Prop({ default: null }) actionParams!: any; //调用接口相关参数【可不传】,配置该参数则表格中增删改查全部在组件内部实现
  @Prop({ default: false }) isDragChange!: Boolean; //	是否通过拖拽改变父子级关系
  @Prop({ default: () => ({}) }) rowStyleConfig!: Function; //行自定义样式
  @Prop({ default: () => false }) isTrigger!: Boolean; //行自定义样式
  @Prop({ default: () => ({}) })
  treeConfig: any | undefined; //展开行配置项
  @Prop({ default: () => 0 })filteringNumbers!: number;//筛选数量
  rowOperationNew: any = { isShow: false };
  gridBoxHeightNow: any = "calc(100% - 30px)";
  heightnum: any = 0; //表格具体高度（数字）
  searchDisplay = "none"; //搜索框默认隐藏
  currentRow: any = {};
  customChangeRows: any = []; //用户程序改过行数据 by msh 20201203
  addData: Array<object> = [];
  chKey = "";
  NewRows: any = []; //记录新增行数据
  defaultRowData = {}; //默认行数据(从配置列数据中获取，新增行时使用)
  editconfig_config: any = {};
  // 内置树配置
  innerTreeConfig = {};
  // 初始化树配置
  initInnerTreeConfig() {
    this.innerTreeConfig = {
      children: "children",
      expandAll: false,
      hasChild: "HasChild",
      lazy: this.isLazy,
      trigger: "row",
      loadMethod: this.loadChildrenMethod2,

    };
    Object.assign(this.innerTreeConfig, this.treeConfig)
  }
  @Watch('treeConfig')
  treeConfigChange(){
    this.initInnerTreeConfig()
  }
    // 监听表格高度发生变化
   @Watch("gridBoxHeight")
  gridBoxHeightChange(Nval) {
    this.gridBoxHeightNow = Nval;
    setTimeout(() => {
      this.heightnum = $("#" + this.gridEleId).height();
    }, 100);
  }
  loadOtherTemp(row) {
    const h = this.$createElement;
    return h("h1", "Hello world!");
  }
  formatDate(value, format) {
    return XEUtils.toDateString(value, format);
  }
  getSelectLabel(value, list, valueProp = "value", labelField = "text") {
    const item = XEUtils.find(list, (item) => item[valueProp] === value);
    return item ? item[labelField] : null;
  }
  getSelectMultipleLabel(
    value,
    list,
    valueProp = "value",
    labelField = "label"
  ) {
    return value
      .map((val) => {
        const item = XEUtils.find(list, (item) => item[valueProp] === val);
        return item ? item[labelField] : null;
      })
      .join(", ");
  }
  editRowEvent(row) {
    (this as any).$refs.xTable.setActiveRow(row);
  }
  cancelRowEvent(row) {
    const xTable = (this as any).$refs.xTable;
    xTable.clearActived().then(() => {
      xTable.revertData(row); // 还原行数据
    });
  }

  //监听编辑框，并修改列值（例如，A列编辑值后需要修改B列值）
  inputEdit(scope, item) {
    this.$emit("input-edit",scope.row);
    (this as any).$refs.xTable.updateStatus(scope);
    this.setCustomChangeRow(scope.row);
    if (item.input_change) {
      item.input_change(scope.row);
    }
  }
  dateChange(row,valueNew){
    this.$emit("dateChange",row,valueNew);
  }
  // expendAll() {
  //   (this as any).$refs.xTable.setAllTreeExpand(true);
  // }
  getTreeGridObj() {
    return (this as any).$refs.xTable;
  }
  /**
   * @description: 懒加载子节点方法
   * @param {*} row
   * @return {*}
   */
  loadChildrenMethod2({ row }) {
    return this.loadChildrenMethod(row); //该方法由父组件传入，在业务中使用
  }
  mounted() {
    this.editconfig_config = this.editconfig;
    if (this.gridType == "view") {
      this.editconfig_config = {};
    }
    if (!this.isNull(this.customRenderer) && Array.isArray(this.customRenderer)) {
      for (const item of this.customRenderer) {
        (VXETable as any).renderer.add(item.name, item.renderer);
      }
    }

    let $this = this;
    //表格行内操作列配置参数 (合并重新赋值)
    this.rowOperationNew = $.extend(
      {
        title: "操作",
        isShow: true,
        width: 110,
        isEditBtn: true,
        isDelBtn: true,
        otherBtn: [],
      },
      this.rowOperation
    );
    this.gridBoxHeightNow = this.gridBoxHeight
    setTimeout(() => {
      this.heightnum = $("#" + $this.gridEleId).height();
      if (this.gridBoxHeight == "auto") {
        this.heightnum = undefined;
      }
    }, 100); 
    this.ColConfig.forEach((item, index) => {
      if (!this.isNull(item.key)) {
        this.defaultRowData[item.key] = "";
      }
    });
    this.loadGridDataToApi();
    this.initInnerTreeConfig()
  }

  // 监听customRenderer改变
  @Watch("customRenderer")
  customRendererChange() {
    for (const item of this.customRenderer) {
      (VXETable as any).renderer.add(item.name, item.renderer);
    }
  }
  // 监听gridData改变（勿删，加上可防止报警告）
  @Watch("gridData")
  gridDataChange() {} 
  /**
   * @description: 调接口请求列表数据
   * @param {*}
   * @return {*}
   * @author: pangting
   */
  async loadGridDataToApi() {
    if (this.actionParams) {
      if (this.isNull(this.actionParams.defaultFilter)) {
        this.actionParams.defaultFilter = "1 = 1";
      }
      this.gridData.splice(0, this.gridData.length); //清空表格数据\
      let getMethod = this.actionParams.getMethod
        ? this.actionParams.getMethod
        : "getEntities";
      let data = this.parseApiResult(
        await this.actionParams.api[getMethod](this.actionParams.defaultFilter)
      );
      let res = this.getTreeListData(data);
      res.forEach((element) => {
        this.gridData.push(element);
      });
    }
  }
  async reloadGridDataToApi(param) {
    if (param) {
      this.gridData.splice(0, this.gridData.length); //清空表格数据\
      let getMethod = param.getMethod ? param.getMethod : "getEntities";
      let data = this.parseApiResult(
        await this.actionParams.api[getMethod](param)
      );
      let res = this.getTreeListData(data);
      res.forEach((element) => {
        this.gridData.push(element);
      });
    }
  }
  /**
   * @description: 调接口保存数据
   * @param {*} editData 新增、编辑过的数据
   * @return {*}
   * @author: pangting
   */
  async saveGridDataToApi(editData) {
    if (this.actionParams) {
      let saveMethod = this.actionParams.saveMethod
        ? this.actionParams.saveMethod
        : "saveTree";
      let res = this.parseApiResult(
        await this.actionParams.api[saveMethod](editData)
      );
      if (res > 0) {
        this.success("保存成功");
        this.loadGridDataToApi();
      }
    }
  }
  /**
   * @description: 调接口删除数据
   * @param {*} row 行数据
   * @return {*}
   * @author: pangting
   */
  async delRowToApi(row) { 
    if (this.actionParams) {
      let delMethod = this.actionParams.delMethod
        ? this.actionParams.delMethod
        : "delete";
      let res = await this.actionParams.api[delMethod](row.Id);
      if (res.code == 200) {
        this.success("删除成功");
        this.loadGridDataToApi();
      }
    }
  }
  //选中某行触发事件
  RowCurrentEvent(row) {
    this.currentRow = row.row;
    //console.log(this.currentRow)
    this.$emit("row-selected", this.currentRow);
  }
  //获取当前选择行数据
  getSelectRow() {
    return this.currentRow;
  }
  RowClickEvent(row, index) {
    // 单击事件
    this.$emit("row-click", row, index);
  }
  RowdbClickEvent(row, index) {
    //双击事件
  }
  //搜索框隐藏/显示
  searchToggle() {
    debugger
    if (this.searchDisplay == "none") {
      this.searchDisplay = "block";
      let searchH = $("#" + this.gridBoxId + " .searchDiv").height();
      this.gridBoxHeightNow = this.heightnum - searchH + "px";
      this.heightnum = this.heightnum - searchH;
    } else {
      let searchH = $("#" + this.gridBoxId + " .searchDiv").height();
      this.searchDisplay = "none";
      this.gridBoxHeightNow = this.gridBoxHeight;
      this.heightnum = this.heightnum + searchH;
    }
  }
  searchFun(param) {
    let searchParam = "";
    for (const key in param) {
      if (!this.isNull(param[key])) {
        searchParam += key + " like '%" + param[key] + "%' and ";
      }
    }
    searchParam = searchParam.substring(0, searchParam.length - 5);
    if (searchParam.length == 0) {
      searchParam = "1 = 1";
    }
    this.$emit("on-search", searchParam, param);
  }
  toggleItem(row, status = true) {
    //展开或关闭结点
    (this as any).$refs.xTable.setTreeExpand(row, status);
  }
  addFun() {
    if (this.toolBarClick.AddFun) {
      //外挂添加
      this.toolBarClick.AddFun();
    } else if (this.toolBarClick.addFun) {
      //外挂添加
      this.toolBarClick.addFun();
    } else {
      this.addRowFun();
    }
  }
  addRowFun(addData: any = {}) {
    let gridObj = (this as any).$refs.xTable;
    let currentRow = this.currentRow;
    debugger
    let rowId = this.NewGuid();
    let addRow1: any = {
      children: [],
      $IsAdd: true,
    };
    addRow1 = Object.assign(
      JSON.parse(JSON.stringify(this.defaultRowData)),
      addRow1
    );
    let addRow = $.extend(addRow1, addData);
    addRow[this.rowKey] = rowId;
    addRow.TemId = rowId;
    addRow.FakeId = rowId; //假Id保存树形结构使用
    addRow.PId = 0;
    addRow.FakePId = 0;
    addRow.NodeLevel = 1;
    addRow.hasChild = 0;
    addRow.HasChild = 0;
    addRow.RootId = 0;
    addRow.ParentPath = "/";
    if (currentRow[this.rowKey]) {
      //添加子节点
      addRow.PId = currentRow.TemId ? 0 : currentRow[this.rowKey];
      addRow.FakePId = currentRow[this.rowKey];
      addRow.RootId = this.currentRow.RootId; //根节点Id
      addRow.NodeLevel =
        (this.currentRow._treeLevel
          ? this.currentRow._treeLevel
          : this.currentRow.NodeLevel) + 1;
      addRow.ParentPath = currentRow.TemId
        ? "/"
        : this.currentRow.ParentPath + this.currentRow[this.rowKey] + "/";
        if(! this.currentRow.children) this.currentRow.children=[];
      this.currentRow.children.unshift(addRow);
      this.currentRow.hasChild = this.currentRow.children.length > 0 ? 1 : 0;
      this.setCustomChangeRow(this.currentRow);
      gridObj.setTreeExpand(this.currentRow, false);
      gridObj.setTreeExpand(this.currentRow, true);
    } else {
      this.gridData.unshift(addRow);
    }
    this.NewRows.push(addRow);
    // if(this.gridType=="edit"){
    gridObj.setActiveRow(addRow); //设置为可编辑状态
    // }
    return addRow;
  }
  /**
   * 手动设置修改过的行 by msh 2020 12 03
   */
  setCustomChangeRow(row) {
    let updateRecords = (this as any).$refs.xTable.getUpdateRecords();
    //Id 判定
    let adults = updateRecords.filter((u) => u.Id === row.Id);
    if (adults.length > 0) return;
    adults = this.NewRows.filter((u) => u.Id === row.Id);
    if (adults.length > 0) return;
    adults = this.customChangeRows.filter((u) => u.Id === row.Id);
    if (adults.length > 0) return;
    else this.customChangeRows.push(row);
  }
  /**
   * 获取添加/编辑数据
   * @param {*}
   * @return {*}
   */
  getEditDataForGrid() {
    let gridObj = (this as any).$refs.xTable;
    let updateRecords = gridObj.getUpdateRecords();
    let insertRecords = this.NewRows;
    for (const xobj of updateRecords) {
      let adults = insertRecords.filter(
        (u) => u[this.rowKey] === xobj[this.rowKey]
      );
      if (adults.length == 0) {
        insertRecords.push(xobj);
      }
    }
    // console.log("Insert"+JSON.stringify(insertRecords));
    let editData = insertRecords.concat(this.customChangeRows);
    //在这里实现去重的方法
    let updateAddData: any = [];
    for (const rows of editData) {
      let adults = updateAddData.filter((u) => Number(u.Id) == Number(rows.Id));
      if (adults.length <= 0) {
        let pruerow = JSON.parse(JSON.stringify(rows));
        pruerow.children = [];
        updateAddData.push(pruerow);
      }
    }
    updateAddData.forEach((item, index) => {
      if (item.$IsAdd) {
        item.Id = 0;
      }
    });
    this.NewRows = []; //清空
    this.customChangeRows = []; //清空
    //  console.log("all"+JSON.stringify(updateAddData));
    return updateAddData;
  }
  // 表格数据校验
  async validate(successCallBack, errorcallBack) {
    this.NoticeClose();
    const errMap = await this.ref("xTable")
      .fullValidate()
      .catch((errMap) => errMap);
    if (errMap) {
      let msgList = "";
      Object.values(errMap).forEach((errList: any) => {
        errList.forEach((params) => {
          let { rowIndex, column, rules } = params;
          rules.forEach((rule) => {
            msgList += `第 ${rowIndex + 1} 行 ${column.title} 校验错误：${
              rule.message
            }</br>`;
          });
        });
      });
      this.NoticeShow("校验失败", msgList, "warning", 20);
      if (errorcallBack) errorcallBack(msgList);
    } else {
      if (successCallBack) {
        successCallBack();
      }
    }
  }
  //保存方法
  saveFun() {
    let editData = this.getEditDataForGrid();
    if (editData.length == 0) {
      this.warning("您还未添加或修改任何数据！");
      return;
    }
    this.validate(() => {
      if (this.toolBarClick.saveFun) {
        this.toolBarClick.saveFun(editData);
        return;
      }
      this.saveGridDataToApi(editData);
    }, null);
  }
  deleteClickRow(e, row) { 
    e.stopPropagation(); //阻止冒泡
    if (row[this.rowKey] && !row.$IsAdd) {
      if (null != row.children && row.children.length > 0) {
        this.confirm(
          "该节点下有子节点，确定要删除" +
            (row[this.delMsgKey] ? row[this.delMsgKey] : "该条数据") +
            "吗?请谨慎操作！",
          () => {
            if (this.rowOperationNew.delRowEvent) {
              this.rowOperationNew.delRowEvent(row);
              return;
            }
            this.delRowToApi(row);
          }
        );
      } else {
        this.confirm(
          "确定要删除" +
            (row[this.delMsgKey] ? row[this.delMsgKey] : "该条数据") +
            "吗?",
          () => {
            if (this.rowOperationNew.delRowEvent) {
              this.rowOperationNew.delRowEvent(row);
              return;
            }
            this.delRowToApi(row);
          }
        );
      }
    } else {
      this.NewRows.forEach((item, index) => {
        if (item[this.rowKey] == row[this.rowKey]) {
          this.NewRows.splice(index, 1);
          return;
        }
      });
      this.delTreeListInfoById(row[this.rowKey]);
      if (row.PId == 0 && row.FakePId) {
      } else {
        let parentRow: any = this.getRowByRowKey(row.PId ? row.FakePId : 0);
        parentRow.hasChild = parentRow.children.length > 0 ? 1 : 0;
        parentRow.HasChild = parentRow.children.length > 0 ? 1 : 0;
      }
    }
  }
  /**
   * @description: 刷新表格数据（从第一页开始） 该方法用来供组件外部刷新表格调用
   * @param {*} filter  筛选条件
   * @return {*}
   * @author: zpf
   */
  refreshGridData(filter) {
    this.reloadGridDataToApi(filter);
  }
  delTreeListInfoById(Id, data: any = []) {
    let _this = this;
    var griddata = data.length > 0 ? data : this.gridData;
    griddata.forEach((item: any, index) => {
      if (item[this.rowKey] == Id) {
        console.log(Id);
        griddata.splice(index, 1);
        return;
      }
      if (item.children && item.children.length > 0) {
        _this.delTreeListInfoById(Id, item.children);
      }
    });
  }

  getRowByRowKey(Id, data: any = [],rowData={}) {
    var griddata = data.length > 0 ? data : this.gridData;
    griddata.forEach((item: any, index) => {
      if (item[this.rowKey] == Id) {
        rowData = item;
      }else{
        if (item.children && item.children.length > 0) {
          this.getRowByRowKey(Id, item.children,rowData);
        }
      }
    });
    return rowData;
  }

  // 刷新按钮
  refreshFun() {
    this.NewRows = [];
    (this as any).$refs.xTable.clearCurrentRow();
    this.currentRow = {};
    if (this.toolBarClick.refreshFun) {
      this.toolBarClick.refreshFun();
      return;
    }
    this.loadGridDataToApi();
  }
  clearFun() {
    (this as any).$refs.xTable.clearCurrentRow();
    this.currentRow = {};
  }
  // 清空数据
  resetData() {
    this.addData = [];
  }
  checkboxChange(param) {
    this.$emit("on-check", param.row, param.checked);
  }
  TreeNodeToggle(param) {
    //懒加载使用结点触发
    this.$emit("on-nodeStatusToggle", param.row, param.expanded);
  }
  /**
   * @description: 用于 type=checkbox，设置行为选中状态，第二个参数为选中与否
   * @param {*} rows    行数据（数组）
   * @param {*} state   状态 -- 选中与否，不传默认选中
   * @return {*}
   */
  checkedRows(rows, state = true) {
    this.setCheckboxRow(rows, state);
  }
  setCheckboxRow(rows, state = true) {
    (this as any).$refs.xTable.setCheckboxRow(rows, state);
  }
  /**
   * @description: 用于 type=checkbox，设置所有行的选中状态
   * @param {*} state  不传默认选中
   * @return {*}
   */
  setAllCheckboxRow(state = true) {
    (this as any).$refs.xTable.setAllCheckboxRow(state);
  }
  /**
   * @description: 用于 type=checkbox，切换某一行的选中状态
   * @param {*} row 行数据
   * @return {*}
   */
  toggleCheckboxRow(row) {
    (this as any).$refs.xTable.toggleCheckboxRow(row);
  }
  /**
   * @description: 用于 type=checkbox，切换所有行的选中状态
   * @param {*}
   * @return {*}
   */
  toggleAllCheckboxRow() {
    (this as any).$refs.xTable.toggleAllCheckboxRow();
  }
  /**
   * @description: 获取grid选中行数据
   * @param {*}
   * @return {*}
   */
  getCheckedRowData() {
    return (this as any).$refs.xTable.getCheckboxRecords();
  }
  /**
   * @description: 设置所有树节点的展开与否
   * @param {*} state
   * @return {*}
   */
  setAllTreeExpand(state) { 
    if(state)
    (this as any).$refs.xTable.setAllTreeExpand(true);
    else
    (this as any).$refs.xTable.clearTreeExpand();
  }
  /**
   * @description: 设置展开树形节点
   * @param {*} row
   * @param {*} state
   * @return {*}
   */
  setTreeExpand(row, state) {
    (this as any).$refs.xTable.setTreeExpand(row, state);
  }
  /**
   * @description: 选中某行
   * @param {*} row
   * @return {*}
   */
  setCurrentRow(row) {
    (this as any).$refs.xTable.setCurrentRow(row);
    this.currentRow = row;
  }
  setCheckRowsByIds(ids, state) {
    let rows = this.loadCheckRowsByIdsData(ids, this.gridData, []);
    this.checkedRows(rows, state);
  }
  loadCheckRowsByIdsData(ids, datas, rows: any) {
    
    datas.forEach((item, index) => {
      if (item&& ids.indexOf(item[this.rowKey]) >= 0) {
        rows.push(item);
      }
      if (item&&item.children && item.children.length > 0) {
        this.loadCheckRowsByIdsData(ids, item.children, rows);
      }
    });
    return rows;
  }
  /**
   * @description: 拖动改变父子级关系回调
   * @param {*} dragOldRowData   被拖动的行    新的子
   * @param {*} dragNewRowData   拖动至此行下  新的父级
   * @return {*}
   * @author: pangting
   */
  dragChangedFun(dragOldRowData, dragNewRowData) {
    this.$emit("dragChanged", dragOldRowData, dragNewRowData);
  }
  // 拖动执行父子级关系后更改界面
  dragFunSuccess(dragOldRowData, dragNewRowData) {
    this.delTreeListInfoById(dragOldRowData.id);
    dragNewRowData.children.push(dragOldRowData);
    dragOldRowData.pid = dragNewRowData.id;
    setTimeout(() => {
      this.setTreeExpand(dragNewRowData, true);
    }, 100);
    // this.$emit("delTreeListInfoById",dragOldRowData.id);
    // dragNewRowData.children.push(dragOldRowData)
    // setTimeout(() => {
    //   this.$emit("setTreeExpand",dragNewRowData,true);
    // }, 100);
  }
}
